import { render, staticRenderFns } from "./FlexibleRulesComponent.vue?vue&type=template&id=33ef9e34&scoped=true"
import script from "./FlexibleRulesComponent.vue?vue&type=script&lang=js"
export * from "./FlexibleRulesComponent.vue?vue&type=script&lang=js"
import style0 from "./FlexibleRulesComponent.vue?vue&type=style&index=0&id=33ef9e34&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef9e34",
  null
  
)

export default component.exports